import { createQueryKeys } from '@lukemorales/query-key-factory';
import { voucherList, VoucherListParams } from 'services/api/conversation';

export const coupons = createQueryKeys('coupons', {
  list: (params: VoucherListParams) => ({
    queryKey: [params],
    queryFn: () => voucherList(params),
  }),
});
